import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const AdminEnquiry = () => {
    const [logout, setLogout] = useState(false);
    const navigate = useNavigate();
    const [enquiry, setEnquiry] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn', 'true');
        navigate('/');
        window.location.reload();
    }


    useEffect(() => {
        fetchEnquiry();
    }, []);


    const fetchEnquiry = async () => {
        setLoading(true);
        try {
            const response = await fetch('http://localhost:3004/api/get-enquiry');

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                data.sort((a, b) => new Date(b.enquire_on) - new Date(a.enquire_on));
                setEnquiry(data);
                setLoading(false);
            } else {
                setLoading(false);
                console.error('Failed to fetch coupon');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).replace(',', '');
    };


    return (
        <>
            <div className='sidebar-left'>
                <span className='sidebar-icon' onClick={() => navigate('/dashboard')}><i class="fa-solid fa-house"></i></span><br /><br />
                <span className='sidebar-icon' onClick={() => navigate('/enquiry')}><i class="fa-solid fa-circle-question"></i></span><br /><br />
                <span className='sidebar-icon' onClick={() => setLogout(true)}><i class="fa-solid fa-power-off"></i></span>
            </div>

            <div className='sidebar-right'>
                <div className='sidebar-right-inner'>
                    <p className='fw-bold fst-italic fs-5 text-nowrap my-3 me-2'>Hello Admin!</p>
                    <p className='fw-semibold fst-italic my-3 bg-warning px-2 py-2 rounded'>Site Enquiry! Check the enquiries made on your site.</p>

                    {loading && <p className='text-center my-5 py-5'><i class="fa-solid fa-circle-notch fa-spin fs-2 py-5"></i></p>}

                    <div className='table-responsive'>
                        <table className='w-100'>
                            <tr className='bg-dark text-light'>
                                <th className='px-2 py-2 rounded-start'>Enquire On</th>
                                <th className='px-2 py-2'>Name</th>
                                <th className='px-2 py-2'>Mobile</th>
                                <th className='px-2 py-2'>Email</th>
                                <th className='px-2 py-2 rounded-end'>Description</th>
                            </tr>


                            {enquiry.map(enq => (
                                <tr className='border-bottom'>
                                    <td className='px-2 py-2'>{formatDateTime(enq.enquire_on)}</td>
                                    <td className='px-2 py-2'>{enq.name}</td>
                                    <td className='px-2 py-2'>{enq.phone}</td>
                                    <td className='px-2 py-2'>{enq.email}</td>
                                    <td className='px-2 py-2'>{enq.subject}</td>
                                </tr>
                            ))}

                        </table>
                    </div>

                </div>
            </div>


            {logout && (
                <div className='dialog-outer px-2'>
                    <div className='dialog-inner col-lg-5 mx-auto py-5'>

                        <p className='fs-5 fw-bold mb-4'>Logout Admin Account!</p>

                        <button className='submit-btn px-3 py-2' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
                        <button className='submit-btn px-3 py-2' onClick={() => setLogout(false)}>No</button>


                    </div>
                </div>
            )}


        </>
    )
}

export default AdminEnquiry




// https://api.shaktitours.com